export const APP_SETTINGS = {
    //url: "https://localhost:3333"
    url: "https://no-line.app"
    ,isFree: true
    ,monthlySubscription: 29
    ,frequency:'monthly'
    ,currency:'eur'
    //,api: "https://localhost:3333/api"
    ,api:  "https://no-line.app/api"
    ,stripeKey: 'pk_test_51NEDNaBvxzL1JoM9wrqnar0IkvyR5J6Tz4mvcP77x2821PQRfaDiSyb2bZqqrChAj9R7WMmxUly4mKwd93FTn89K00mdaZyZYM'
    ,stripeBaseUrl: 'https://api.stripe.com'
    ,languagesFiles: {
        it: '/languages/client-portal/it.json'
        ,en: '/languages/client-portal/en.json'
        ,de: '/languages/client-portal/de.json'
    }
}